import { Button, Stack, styled } from "@mui/material";
import React from "react";
import { CheckboxComponent, TextFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import { SpinnerWrapper } from "../SpinnerWrapper";
import OpsDialogImage from "../OpsDialogImage";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Badge from "../../models/Badge";
import { useStyles } from "../Main/formStyles";
import { Token } from "../../theme";

interface Props {
  onClose: () => void;
  isLoading: boolean;
  open: boolean;
  handleUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleOnCreateBadge: (instance: Badge) => void;
  handleImageDelete: () => void;
  selectedFile: string;
}

export default function BadgeCreateDialog(props: Props) {
  const customStyles = useStyles();

  return (
    <>
      {props.open ? (
        <GenericForm<Badge>
          headerStyles={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}
          buttonStyles={{ marginRight: 20, color: "white", backgroundColor: Token.actionPrimary, marginBottom: 10 }}
          cancelButtonStyles={{
            color: Token.textSecondary,
            border: `1px solid ${Token.borderDefault}`,
            marginBottom: 10,
          }}
          dialogStyles={customStyles.root}
          dialog={true}
          open={!!props.open}
          title={"Create new Badge"}
          onSave={(instance) => {
            instance.iconUrl = props.selectedFile;
            setTimeout(() => {
              props.onClose();
            }, 500);
            props.handleOnCreateBadge(instance);
          }}
          onCancel={() => props.onClose()}
          dialogCustomSubmitMessage={"Save"}
          renderContent={(register, errors, control) => (
            <>
              <SpinnerWrapper isLoading={props.isLoading}>
                <OpsDialogImage viewMode={false} selectedFile={props.selectedFile} onDelete={() => props.handleImageDelete()} />

                <Stack direction="row">
                  <label htmlFor="contained-button-file">
                    <Input
                      id="contained-button-file"
                      type="file"
                      accept=".jpeg, .jpg, .png, .gif, .bmp"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.handleUploadImage(e)}
                    />
                    <SpinnerWrapper isLoading={props.isLoading}>
                      <Button startIcon={<FileUploadIcon />} variant="contained" component="span" sx={{ margin: ".7em" }}>
                        Choose Image
                      </Button>
                    </SpinnerWrapper>
                  </label>
                </Stack>

                <TextFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"name"}
                  label="Title"
                  required={true}
                  size="small"
                />

                <TextFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"description"}
                  label="Description"
                  required={true}
                  internalProps={{ multiline: true, rows: 6 }}
                  size="small"
                />

                <CheckboxComponent
                  propertyName={"automaticApproval"}
                  label={"Automatic Approval"}
                  control={control}
                  register={register}
                  errors={errors}
                />
                <CheckboxComponent propertyName={"level"} label={"Level Option"} control={control} register={register} errors={errors} />
              </SpinnerWrapper>
            </>
          )}
        />
      ) : null}
    </>
  );
}
const Input = styled("input")({
  display: "none",
});
